import { useState } from "react";
import { hotRankList } from "@/mocks/guaHot";

type Tab = "all" | "hot" | "new";

const TABS: { key: Tab; label: string }[] = [
  { key: "all", label: "全站热榜" },
  { key: "hot", label: "持续升温" },
  { key: "new", label: "刚刚上榜" },
];

export default function Trending() {
  const [tab, setTab] = useState<Tab>("all");

  const list = hotRankList.filter((h) => {
    if (tab === "hot") return h.trend === "up";
    if (tab === "new") return h.delta.includes("首次上榜");
    return true;
  });

  const maxHeat = 986.2;

  return (
    <section id="trend" className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="text-xs font-semibold tracking-[0.2em] text-red-700">实时热议榜</p>
            <h2 className="font-masthead mt-2 text-2xl font-black text-stone-900 md:text-3xl">
              全网热搜实时榜
            </h2>
            <p className="mt-2 text-sm text-stone-500">按当前全网讨论热度实时更新，第一时间掌握事件走向。</p>
          </div>
          <div className="inline-flex self-start items-center gap-1 rounded-full border border-orange-900/15 bg-[#faf6ee] p-1 sm:self-auto">
            {TABS.map((t) => (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                  tab === t.key
                    ? "bg-red-700 text-white"
                    : "text-stone-600 hover:text-red-700"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <ol className="mt-6 grid gap-2 md:grid-cols-2">
          {list.map((h) => {
            const ratio = Math.max(6, Math.round((parseFloat(h.heat) / maxHeat) * 100));
            return (
              <li
                key={h.rank}
                className="flex items-center gap-4 rounded-lg border border-orange-900/10 bg-[#faf6ee] px-4 py-3"
              >
                <span
                  className={`font-masthead w-8 shrink-0 text-center text-xl font-black leading-none ${
                    h.rank <= 3 ? "text-red-700" : "text-stone-300"
                  }`}
                >
                  {h.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-3">
                    <a href="#news" className="line-clamp-2 text-sm font-medium text-stone-800 hover:text-red-700">
                      {h.title}
                    </a>
                    <span
                      className={`shrink-0 rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                        h.tag === "沸"
                          ? "bg-red-700 text-white"
                          : h.tag === "热"
                          ? "bg-orange-500 text-white"
                          : "bg-amber-100 text-amber-900"
                      }`}
                    >
                      {h.tag}
                    </span>
                  </div>
                  <div className="mt-2 flex items-center gap-2">
                    <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-orange-900/10">
                      <div className="h-full rounded-full bg-gradient-to-r from-amber-400 to-red-600" style={{ width: `${ratio}%` }}></div>
                    </div>
                    <span className="shrink-0 text-xs text-stone-400">{h.heat}</span>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}